import { Routes } from '@angular/router';
import { configureNoPermissionsRoute } from '@psu-pennstateit-swe/apis/fortress';
import { FortressPermissions, hasPermissionGuard } from './app.permissions';
import { FortressComponent } from './fortress/fortress.component';
import { NoPermissionsComponent } from './no-permissions/no-permissions.component';
import { RoutePaths } from './route-paths.model';
import { ToolbarContextComponent } from './toolbar-context/toolbar-context.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: RoutePaths.Base,
    pathMatch: 'full',
  },
  {
    path: RoutePaths.Base,
    component: FortressComponent,
    children: [
      { path: '', redirectTo: RoutePaths.Roles, pathMatch: 'full' },
      // The toolbar outlet route data is used to display the toolbar subtitle text
      {
        path: '',
        outlet: 'toolbar',
        component: ToolbarContextComponent,
        data: {
          title: 'Role Based Access Control',
          titleMobile: 'RBAC',
        },
      },
      {
        path: `${RoutePaths.Permissions}/:permObj/:permOp`,
        loadComponent: () =>
          import('./fortress/permission-details/permission-details.component').then(
            (m) => m.PermissionDetailsComponent,
          ),
        title: 'Permission Details | Fortress | Penn State',
      },
      {
        path: `${RoutePaths.Permissions}/:permObj`,
        loadComponent: () =>
          import('./fortress/permission-object-details/permission-object-details.component').then(
            (m) => m.PermissionObjectDetailsComponent,
          ),
        title: 'Permission Object Details | Fortress | Penn State',
      },
      {
        path: `${RoutePaths.Users}/:userId`,
        loadComponent: () =>
          import('./fortress/user-details/user-details.component').then((m) => m.UserDetailsComponent),
        title: 'User Details | Fortress | Penn State',
      },
      {
        path: `${RoutePaths.Roles}/:roleName`,
        loadComponent: () =>
          import('./fortress/role-details/role-details.component').then((m) => m.RoleDetailsComponent),
        title: 'Role Details | Fortress | Penn State',
        canActivate: [hasPermissionGuard(FortressPermissions.CanViewRoles)],
      },
      {
        path: RoutePaths.Roles,
        loadComponent: () => import('./fortress/rbac/rbac.component').then((m) => m.RbacComponent),
        title: 'Roles | Fortress | Penn State',
        canActivate: [hasPermissionGuard(FortressPermissions.CanViewRoles)],
      },
    ],
  },
  configureNoPermissionsRoute(NoPermissionsComponent),
  { path: '**', loadComponent: () => import('./not-found/not-found.component').then((m) => m.NotFoundComponent) },
];
